import { render, staticRenderFns } from "./entry-editor.vue?vue&type=template&id=2beaff85&scoped=true&"
import script from "./entry-editor.vue?vue&type=script&lang=js&"
export * from "./entry-editor.vue?vue&type=script&lang=js&"
import style0 from "./entry-editor.vue?vue&type=style&index=0&id=2beaff85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beaff85",
  null
  
)

export default component.exports